    export class GameVars {

        public static scaleX: number;
        public static noBloodMode: boolean;
        public static gameData: GameData;
        public static paused: boolean;
        public static randomDataGenerator: Phaser.RandomDataGenerator;
        public static freezeAction: boolean;
        public static featherSpeed: boolean;
        public static riverSide: string;
        public static trunksLine: string;
        public static savedChicken: number;
        public static deaths: number;
        public static drowned: number;
        public static feathers: number;
        public static score: number;
        public static crosses: number;
        public static time: number;
        public static chickenTime: number;
        public static streak: number;
        public static gameOver: boolean;
        public static laggedAchievements: number[];

        // GAMEPIND
        public static gamepindUser: any;

        public static areValidDomains(domains: string[]): boolean {

            let isValid = false;

            for (let i = 0; i < domains.length; i++) {
                if (window.location.hostname.indexOf(domains[i]) !== -1) {
                    isValid = true;
                    break;
                }
            }

            return isValid;
        }
    }
